export default __webpack_public_path__ + "static/media/noun-download-2633546.55d0c702.svg";